// extracted by mini-css-extract-plugin
module.exports = {"list":"DeleteCard_list_3PirU","card":"DeleteCard_card_2e7Lo","icon":"DeleteCard_icon_2emgA"};